<nb-card>
  <nb-card-header>
    <span>Gebäude</span>
  </nb-card-header>
  <wr-table [rows]="buildings()" [loading]="isLoading()" [rowLink]="getBuildingLink" [(sort)]="sort">
    <wr-table-pagination [totalRows]="buildingCount()"
                         [(pageSize)]="pageSize"
                         [(page)]="page"></wr-table-pagination>
    <ng-template column let-building [of]="buildings()" header="Adresse" sort="sectionText">
      {{ building.baseData.sectionText }}
    </ng-template>
    <ng-template column let-building [of]="buildings()" header="Name" sort="name">
      {{ building.baseData.name }}
    </ng-template>
    <ng-template column let-building [of]="buildings()" header="Kunde">
      {{ building.ownerTenant.name }}
    </ng-template>
    <ng-template column let-building [of]="buildings()" header="Interne Nummer" sort="internalNumber">
      {{ building.internalNumber }}
    </ng-template>
    <ng-template column let-building [of]="buildings()" header="Zustand">
      <wr-building-condition *ngIf="building.buildingCondition.conditionValue > 0"
                             [condition]="building.buildingCondition.conditionValue" />
    </ng-template>
  </wr-table>
</nb-card>
